export const MarginBonusEvent = {
  OrderFormBonusExpiryPopupView: 'order_form_bonus_expiry_popup_view',
  OrderFormBonusExpiryPopupDepositClick: 'order_form_bonus_expiry_popup_deposit_click',
  UsdtBonusPageDetailClick: 'usdt_bonus_page_detail_click',
  OrderNotPlacedAutoLeveragePopupView: 'order_not_placed_auto_leverage_popup_view',
  PositionAdjustmentUnavailablePopupView: 'position_adjustment_unavailable_popup_view',
} as const;

export interface MarginBonusEventDataType {
  [MarginBonusEvent.OrderFormBonusExpiryPopupView]: {
    amount_expiring: string;
    expiry_date: string;
  };
  [MarginBonusEvent.OrderFormBonusExpiryPopupDepositClick]: {
    amount_expiring: string;
    expiry_date: string;
  };
  [MarginBonusEvent.UsdtBonusPageDetailClick]: {
    section_name: string;
  };
}
